import React, { useCallback, useMemo } from "react";
import { ListItemButton, Typography, Box } from "@mui/material";
import CustomButton from "./default/CustomButton";

interface ITabType {
    label: string;
}

interface ISidebarProps {
    tabs: ITabType[];
    parameters?: { main: any[]; additional: { count: number; [key: string]: unknown } | null };
    selectedTab: number;
    onSelectTab: (index: number) => void;
}

const Sidebar: React.FC<ISidebarProps> = ({ tabs, parameters, selectedTab, onSelectTab }) => {
    const handleListItemClick = useCallback(
        (event: React.MouseEvent<HTMLDivElement, MouseEvent>, index: number) => {
            onSelectTab(index);
        },
        [onSelectTab]
    );

    const renderTabs = useMemo(
        () =>
            tabs.map((tab, index) => (
                <Box
                    key={index}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {parameters && parameters.main && parameters.main[index] && index < parameters.main.length && (
                        <CustomButton
                            label={String(parameters.main[index]["selected"].length)}
                            sx={{
                                width: "28px",
                                color: "white",
                                height: "28px",
                                flexShrink: 0,
                            }}
                        />
                    )}

                    {parameters && parameters.additional !== null && index >= parameters.main.length && (
                        <CustomButton
                            label={String(parameters.additional["count"])}
                            sx={{
                                width: "28px",
                                color: "white",
                                height: "28px",
                                flexShrink: 0,
                            }}
                        />
                    )}

                    <ListItemButton
                        key={tab.label}
                        selected={selectedTab === index}
                        onClick={(event) => handleListItemClick(event, index)}
                        sx={{
                            width: "100%",
                            borderRadius: "20px",
                            margin: "5px 0px 5px 0px",
                            maxWidth: "100%",
                        }}
                    >
                        <Typography
                            noWrap
                            sx={{
                                width: "100%",
                                maxWidth: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis", // optional: adds ellipsis for long text
                            }}
                        >
                            {tab.label}
                        </Typography>
                    </ListItemButton>
                </Box>
            )),
        [handleListItemClick, parameters, selectedTab, tabs]
    );

    return (
        <Box
            sx={{
                maxWidth: "100%",
                display: "flex",
                flexDirection: "column",
                float: "left",
                position: "relative",
                width: "100%",
            }}
        >
            {renderTabs}
        </Box>
    );
};

export default React.memo(Sidebar);
